import { Star } from "lucide-react";

interface GoogleReviewBadgeProps {
  rating?: number;
  variant?: "inline" | "block";
  className?: string;
  profileUrl?: string;
}

const GOOGLE_PROFILE_URL = "https://share.google/BnYOuRH1kPhNa4BeV";

export const GoogleReviewBadge = ({ 
  rating = 5.0, 
  variant = "inline",
  className = "",
  profileUrl = GOOGLE_PROFILE_URL
}: GoogleReviewBadgeProps) => {
  const stars = Array.from({ length: 5 }, (_, i) => (
    <Star 
      key={i} 
      className={`h-4 w-4 ${i < Math.floor(rating) ? 'fill-yellow-400 text-yellow-400' : 'text-muted-foreground/30'}`}
    />
  ));

  const content = (
    <>
      <div className="flex items-center gap-0.5">
        {stars}
      </div>
      <span className="text-sm font-medium whitespace-nowrap">
        {rating.toFixed(1)} on Google
      </span>
    </>
  );

  if (variant === "block") {
    return (
      <a 
        href={profileUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex flex-col items-center gap-1 hover:opacity-80 transition-opacity ${className}`}
      >
        <div className="flex items-center gap-1">
          {stars}
        </div>
        <span className="text-sm font-medium">
          {rating.toFixed(1)} on Google
        </span>
      </a>
    );
  }

  return (
    <a 
      href={profileUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent/50 border border-border hover:bg-accent/70 transition-colors ${className}`}
    >
      {content}
    </a>
  );
};
